import { combineReducers } from 'redux'
import locationReducer from './location'
import stepfirstReducer from '../components/StepFirst/modules/stepfirst'
import stepsecondReducer from '../components/StepSecond/modules/stepsecond'
import selectTypeReducer from '../components/SelectTypeComponent/modules/selectType'
import interventionReducer from '../components/InterventionComponent/modules/intervention'
import chartReducer from '../components/ChartsComponent/modules/chartscomponent'

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    location: locationReducer,
    stepfirst: stepfirstReducer,
    stepsecond: stepsecondReducer,
    selecttype: selectTypeReducer,
    intervention: interventionReducer,
    chart: chartReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js